// Heuristic recommender: scans a task for keywords and suggests MCP servers,
// Claude Code skills, and CLI tools that are relevant.

const PATTERNS = [
  {
    name: 'cloudflare',
    kw: ['cloudflare', 'workers', 'wrangler', ' kv ', ' d1 ', ' r2 ', 'durable object', 'pages', 'tunnel'],
    mcp: ['cloudflare', 'cloudflare-bindings', 'cloudflare-observability'],
    skills: ['cloudflare', 'wrangler', 'workers-best-practices', 'durable-objects'],
    tools: ['wrangler deploy', 'wrangler tail', 'wrangler kv', 'wrangler d1'],
  },
  {
    name: 'azure',
    kw: ['azure', 'aks', 'app service', 'azure functions', 'entra', 'keyvault', 'cosmos', 'arm template', 'bicep'],
    mcp: ['azure'],
    skills: ['azure-deploy', 'azure-rbac', 'microsoft-foundry', 'entra-app-registration'],
    tools: ['az cli', 'azd', 'bicep'],
  },
  {
    name: 'supabase',
    kw: ['supabase', 'rls', 'edge function', 'realtime'],
    mcp: ['supabase'],
    skills: ['supabase', 'supabase-postgres-best-practices', 'postgresql'],
    tools: ['supabase cli', 'psql'],
  },
  {
    name: 'neon',
    kw: ['neon', 'serverless postgres', 'branching database'],
    mcp: ['neon'],
    skills: ['neon-postgres', 'neon-instagres'],
    tools: ['psql', 'neon cli'],
  },
  {
    name: 'postgres',
    kw: ['postgres', 'postgresql', 'sql migration', 'pgvector'],
    mcp: ['supabase', 'neon'],
    skills: ['postgresql', 'sql-pro', 'database-architect'],
    tools: ['psql', 'pgcli'],
  },
  {
    name: 'github',
    kw: ['github', 'pull request', ' pr ', 'merge conflict', 'gh actions', 'github actions', 'workflow', 'issue triage'],
    mcp: ['github'],
    skills: ['github-automation', 'github-workflow-automation', 'github-actions-templates'],
    tools: ['gh cli', 'gh pr', 'gh issue'],
  },
  {
    name: 'react-next',
    kw: ['react', 'next.js', 'nextjs', 'app router', 'server component', 'tailwind', 'shadcn', 'vite'],
    mcp: ['vercel'],
    skills: ['react-best-practices', 'vercel:nextjs', 'frontend-design', 'typescript-best-practices', 'ui-design:create-component'],
    tools: ['vercel cli', 'pnpm', 'npm'],
  },
  {
    name: 'vercel',
    kw: ['vercel', 'edge function', 'preview deployment'],
    mcp: ['vercel'],
    skills: ['vercel:deploy', 'vercel:env', 'vercel:vercel-functions'],
    tools: ['vercel cli'],
  },
  {
    name: 'debug',
    kw: ['debug', 'error', 'stack trace', 'crash', 'exception', 'flaky test', 'panic', 'segfault'],
    mcp: ['sentry', 'chrome-devtools'],
    skills: ['sentry:seer', 'chrome-devtools-mcp:chrome-devtools', 'superpowers:systematic-debugging', 'error-diagnostics:smart-debug'],
    tools: ['sentry', 'chrome devtools', 'debugger'],
  },
  {
    name: 'atlassian',
    kw: ['atlassian', 'jira', 'confluence'],
    mcp: ['Atlassian-Rovo'],
    skills: [],
    tools: ['jira api', 'confluence api'],
  },
  {
    name: 'airtable',
    kw: ['airtable', 'base', 'airtable record'],
    mcp: ['Airtable'],
    skills: [],
    tools: ['airtable api'],
  },
  {
    name: 'mermaid',
    kw: ['mermaid', 'flowchart', 'sequence diagram', 'er diagram', 'architecture diagram'],
    mcp: ['Mermaid_Chart'],
    skills: ['c4-architecture'],
    tools: ['mermaid-cli'],
  },
  {
    name: 'huggingface',
    kw: ['huggingface', 'hugging face', ' hf ', 'fine-tune', 'transformer', 'qlora'],
    mcp: ['Hugging_Face'],
    skills: ['llm-application-dev:rag-implementation', 'machine-learning-ops:ml-pipeline-workflow'],
    tools: ['hf cli', 'transformers'],
  },
  {
    name: 'pinecone-rag',
    kw: ['pinecone', 'vector', 'embedding', ' rag ', 'retrieval', 'similarity search', 'semantic search'],
    mcp: ['pinecone'],
    skills: ['pinecone:quickstart', 'llm-application-dev:rag-implementation', 'llm-application-dev:embedding-strategies'],
    tools: ['pinecone cli'],
  },
  {
    name: 'docker',
    kw: ['docker', 'container', 'dockerfile', 'compose'],
    mcp: [],
    skills: ['cicd-automation:github-actions-templates'],
    tools: ['docker', 'docker compose', 'docker buildx'],
  },
  {
    name: 'kubernetes',
    kw: ['kubernetes', ' k8s', 'helm', 'ingress', 'kustomize'],
    mcp: [],
    skills: ['azure:azure-kubernetes', 'cloud-infrastructure:istio-traffic-management', 'cicd-automation:secrets-management'],
    tools: ['kubectl', 'helm', 'kustomize'],
  },
  {
    name: 'security',
    kw: ['security', 'vuln', 'owasp', 'sast', 'threat model', 'pen test', 'auth bypass', 'csrf', 'xss', 'sqli'],
    mcp: [],
    skills: ['senior-security', 'security-scanning:security-sast', 'security-scanning:stride-analysis-patterns'],
    tools: ['semgrep', 'trivy', 'snyk'],
  },
  {
    name: 'testing',
    kw: ['unit test', 'integration test', ' e2e ', 'playwright', 'vitest', 'jest', 'cypress'],
    mcp: ['playwright'],
    skills: ['superpowers:test-driven-development', 'tdd-workflows:tdd-cycle', 'developer-essentials:e2e-testing-patterns'],
    tools: ['vitest', 'playwright', 'jest'],
  },
  {
    name: 'a11y',
    kw: ['accessibility', ' a11y', 'wcag', 'screen reader', 'aria'],
    mcp: ['chrome-devtools'],
    skills: ['ui-design:accessibility-compliance', 'chrome-devtools-mcp:a11y-debugging'],
    tools: ['axe', 'lighthouse'],
  },
  {
    name: 'performance',
    kw: ['performance', 'optimi', 'slow', 'latency', 'core web vitals', ' lcp', ' cls', ' fcp'],
    mcp: ['chrome-devtools'],
    skills: ['application-performance:performance-optimization', 'chrome-devtools-mcp:debug-optimize-lcp', 'web-perf'],
    tools: ['lighthouse', 'chrome devtools', 'speedometer'],
  },
  {
    name: 'data-viz',
    kw: ['chart', 'graph', 'visuali', 'dashboard', 'd3'],
    mcp: [],
    skills: ['d3js-visualization', 'enterprise-data-apps'],
    tools: ['recharts', 'd3.js', 'plotly'],
  },
  {
    name: 'docs',
    kw: ['document', 'readme', 'api doc', 'openapi'],
    mcp: ['context7', 'microsoft-docs'],
    skills: ['doc-coauthoring', 'docs-search'],
    tools: ['mkdocs', 'docusaurus'],
  },
  {
    name: 'pdf',
    kw: ['pdf', 'extract pdf'],
    mcp: [],
    skills: ['pdf'],
    tools: ['pdftotext', 'pypdf'],
  },
  {
    name: 'spreadsheet',
    kw: ['excel', 'spreadsheet', 'xlsx', 'csv', 'tsv'],
    mcp: [],
    skills: ['xlsx', 'enterprise-data-apps'],
    tools: ['pandas', 'openpyxl'],
  },
  {
    name: 'shell',
    kw: ['bash script', 'shell script', 'powershell', 'zsh', 'cron'],
    mcp: [],
    skills: ['shell-scripting:bash-defensive-patterns', 'shell-scripting:shellcheck-configuration'],
    tools: ['shellcheck', 'shfmt'],
  },
  {
    name: 'rust',
    kw: ['rust', 'cargo', 'tokio', 'axum'],
    mcp: [],
    skills: ['systems-programming:rust-async-patterns'],
    tools: ['cargo', 'rustup'],
  },
  {
    name: 'go',
    kw: [' golang', ' go ', 'goroutine', 'channels'],
    mcp: [],
    skills: ['golang-pro', 'systems-programming:go-concurrency-patterns'],
    tools: ['go', 'golangci-lint'],
  },
  {
    name: 'python',
    kw: ['python', ' pip', 'fastapi', 'django', 'pandas'],
    mcp: [],
    skills: ['api-scaffolding:fastapi-templates', 'enterprise-data-apps'],
    tools: ['python', 'uv', 'poetry'],
  },
];

export function recommendFor(task) {
  const lower = ' ' + (task || '').toLowerCase() + ' ';
  if (!lower.trim()) return { mcp: [], skills: [], tools: [], score: 0, hits: [] };
  const mcp = new Map();
  const skills = new Map();
  const tools = new Map();
  const hits = [];
  let score = 0;

  for (const p of PATTERNS) {
    const matched = p.kw.filter((k) => lower.includes(k));
    if (!matched.length) continue;
    score += matched.length;
    hits.push({ name: p.name, matched });
    for (const m of p.mcp) mcp.set(m, (mcp.get(m) || 0) + matched.length);
    for (const s of p.skills) skills.set(s, (skills.get(s) || 0) + matched.length);
    for (const t of p.tools) tools.set(t, (tools.get(t) || 0) + matched.length);
  }

  const top = (m, n) =>
    [...m.entries()]
      .sort((a, b) => b[1] - a[1])
      .slice(0, n)
      .map(([k, weight]) => ({ k, weight }));

  return {
    mcp: top(mcp, 8),
    skills: top(skills, 8),
    tools: top(tools, 8),
    hits,
    score,
  };
}
